(function () {
  const stepNavs = document.querySelectorAll('.step');
  if (!stepNavs.length) return;

  const LARGURA_TELA_MAX = 576;

  function setStepNumProperty(stepNav) {
    const isOrdered = stepNav.querySelector('.step-ordered');
    const isTexto = stepNav.classList.contains('step-texto');

    if (!isOrdered && !isTexto) return;

    const stepItems = stepNav.querySelectorAll('.step-progress-item');

    stepItems.forEach((item) => {
      const hasStatusClass =
        item.classList.contains('step-success') ||
        item.classList.contains('step-danger');
      const stepNum = item.getAttribute('step-num');

      if (!hasStatusClass && stepNum) {
        item.style.setProperty('--step-num', `"${stepNum}"`);
      }
    });
  }

  function verificarLarguraTela() {
    const larguraTela = window.innerWidth;

    const firstStepNav = stepNavs[0];
    const stepProgress = firstStepNav.querySelector('.step-progress');

    const orientationLocked =
      firstStepNav.classList.contains('step-slide') ||
      firstStepNav.classList.contains('step-texto');

    if (larguraTela < LARGURA_TELA_MAX && !orientationLocked) {
      firstStepNav.classList.add('step-vertical');
      stepProgress.setAttribute('aria-orientation', 'vertical');
    } else {
      firstStepNav.classList.remove('step-vertical');
      stepProgress.setAttribute('aria-orientation', 'horizontal');
    }
  }

  stepNavs.forEach(setStepNumProperty);
  verificarLarguraTela();
  window.addEventListener('resize', verificarLarguraTela);
})();
